<template>
  <div>
  <div v-if="activeTab == 1">
    <div class="columns gap2">
      <div class="span-12 columns">

        <div class="span-12 medium-border-radius border-form gap2 mb-1 ph-2 pb-2 pt-2">

          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold mb-1 text-primary"> INFORMAÇÕES GERAIS</h5>
            <span class="title-border-bottom"></span>
          </div>

          <div class="gap1 columns">

            <div class="span-4 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  Status do Parceiro
                </div>
              </div>
              <input type="text" class="mb-05 input-status-custom-broker" v-model="process.statusCustomBroker" :disabled="disableClick" placeholder='' @change="() => inputUpdate('statusCustomBroker')" maxlength="50">
              <small> Já foi digitado {{ process.statusCustomBroker.length}} de um total de 50 caracteres permitidos.</small>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  Nº CE Mercante
                </div>
              </div>
              <input v-model="process.ceMercante" :disabled="disableClick" type="text" @change="() => inputUpdate('ceMercante')"/>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  Situação do CE Mercante
                </div>
              </div>
              <div
                class="ce-mercante-situacao-wrap mb-05"
                :class="[
                  ceMercanteCheckedToneClass,
                  { 'ce-mercante-situacao-wrap--disabled': disableClick },
                ]"
              >
                <select
                  class="ce-mercante-situacao-select"
                  :value="ceMercanteCheckedSelectValue"
                  :disabled="disableClick"
                  aria-label="Situação do CE Mercante — abrir para escolher Pendente, Conferido ou Divergente"
                  title="Clique para ver as opções"
                  @change="onCeMercanteCheckedChange"
                >
                  <option value="null">Pendente</option>
                  <option value="true">Conferido</option>
                  <option value="false">Divergente</option>
                </select>
                <span class="ce-mercante-situacao-chevron" aria-hidden="true">
                  <svg
                    class="ce-mercante-situacao-chevron__svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      stroke-width="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>

            <div class="span-3">
              <div class="flex fd-c  mb-1">
                <div> Referência do Parceiro </div>

              </div>
              <div class="flex fd-c">
                <input v-model="process.customBrokerRef" :disabled="disableClick" class="mb-05 input-status-custom-broker" type="text" @change="() => inputUpdate('customBrokerRef')" maxlength="20"/>
                <small style="margin-bottom: 5px;"> Já foi digitado {{ process.customBrokerRef.length}} de um total de 20 caracteres permitidos.</small>
                <small> Utilize esse campo para informar a referência do despachante.</small>
              </div>
            </div>

          </div>

          <hr class="mb-2 mt-0 hr-tab-general"/>

          <div class="gap1 columns">

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Cliente
                </div>
              </div>
              <span class="result-span">{{process.customer.name ? process.customer.name : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Ref. Pedido / Cliente
                </div>
              </div>
              <span class="result-span">{{process.customerRef ? process.customerRef : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Exportador
                </div>
              </div>
              <span class="result-span">{{process.exporter.name ? process.exporter.name : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Fabricante / Produtor
                </div>
              </div>
              <span class="result-span">{{process.manufacturer.name ? process.manufacturer.name : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Invoice
                </div>
              </div>
              <span class="result-span">{{process.invoice ? process.invoice : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Data Invoice
                </div>
              </div>
              <span class="result-span">{{process.invoiceDate ? formatData(process.invoiceDate) : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Local de Embarque
                </div>
              </div>
              <span class="result-span">{{process.placeOfLoadingEntity?.name ? process.placeOfLoadingEntity?.name : process.placeOfLoading ? process.placeOfLoading : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Outras Referências
                </div>
              </div>
              <span class="result-span">{{process.anotherRef ? process.anotherRef : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Seguro Internacional
                </div>
              </div>
              <span class="result-span">{{process.insuranceAward ? process.insuranceAward : 'N/I'}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Destinação mercadorias
                </div>
              </div>
              <span class="result-span">{{returnProcessUseOfGoods(process.processUseOfGoods)}}</span>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Time Operacional Prime
                </div>
              </div>
              <div class="team-email-display">
                <div
                  v-if="process.team && process.team.email"
                  class="tooltip-team-email"
                >
                  <span class="tooltip-team-email__trigger">
                    <span class="result-span result-span-with-icon">
                      <span class="result-span-with-icon__text">{{ process.team.name }}</span>
                      <InfoIcon size="1rem" class="result-span-with-icon__icon" />
                    </span>
                    <span class="content">{{ process.team.email }}</span>
                  </span>
                </div>
                <span v-else class="result-span">{{ process.team ? process.team.name : 'N/I' }}</span>
                <button
                  v-if="process.team && process.team.email"
                  type="button"
                  class="team-email-copy"
                  @click="copyTeamEmail(process.team.email)"
                >
                  <svg class="team-email-copy__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M8 4V16C8 17.1046 8.89543 18 10 18H18C19.1046 18 20 17.1046 20 16V7.24162C20 6.7034 19.7831 6.18789 19.3983 5.81161L16.0829 2.56999C15.7092 2.20295 15.2081 2 14.6873 2H10C8.89543 2 8 2.89543 8 4Z" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M16 18V20C16 21.1046 15.1046 22 14 22H6C4.89543 22 4 21.1046 4 20V9C4 7.89543 4.89543 7 6 7H8" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <span>copiar email</span>
                </button>
              </div>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  Time Aduaneiro Prime
                </div>
              </div>
              <div class="team-email-display">
                <div
                  v-if="process.customsTeam && process.customsTeam.email"
                  class="tooltip-team-email"
                >
                  <span class="tooltip-team-email__trigger">
                    <span class="result-span result-span-with-icon">
                      <span class="result-span-with-icon__text">{{ process.customsTeam.name }}</span>
                      <InfoIcon size="1rem" class="result-span-with-icon__icon" />
                    </span>
                    <span class="content">{{ process.customsTeam.email }}</span>
                  </span>
                </div>
                <span v-else class="result-span">{{ process.customsTeam ? process.customsTeam.name : 'N/I' }}</span>
                <button
                  v-if="process.customsTeam && process.customsTeam.email"
                  type="button"
                  class="team-email-copy"
                  @click="copyTeamEmail(process.customsTeam.email)"
                >
                  <svg class="team-email-copy__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M8 4V16C8 17.1046 8.89543 18 10 18H18C19.1046 18 20 17.1046 20 16V7.24162C20 6.7034 19.7831 6.18789 19.3983 5.81161L16.0829 2.56999C15.7092 2.20295 15.2081 2 14.6873 2H10C8.89543 2 8 2.89543 8 4Z" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M16 18V20C16 21.1046 15.1046 22 14 22H6C4.89543 22 4 21.1046 4 20V9C4 7.89543 4.89543 7 6 7H8" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <span>copiar email</span>
                </button>
              </div>
            </div>

          </div>
        </div>

        <div class="span-12 medium-border-radius border-form gap2 mb-1 ph-2 pb-2 pt-2" style="background: #fbfbfb;">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold  mb-1 text-primary"> DATAS PREVISTAS </h5>
            <span class="title-border-bottom"></span>
          </div>
          <div class="gap2 columns">

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Prontidão de Carga
                </div>
              </div>
              <span class="result-span">{{process.datesEstimatedGoodsReadinesDate ? formatData(process.datesEstimatedGoodsReadinesDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> ETD Inicial
                </div>
              </div>
              <span class="result-span">{{process.initialDatesETD ? formatData(process.initialDatesETD) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> ETD
                </div>
              </div>
              <span class="result-span">{{process.datesETD ? formatData(process.datesETD) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> ETA
                </div>
              </div>
              <span class="result-span">{{process.datesETA ? formatData(process.datesETA) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Numerário
                </div>
              </div>
              <span class="result-span">{{process.estimatedStepCashRequest ? formatData(process.estimatedStepCashRequest) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Entrega no Cliente
                </div>
              </div>
              <span class="result-span">{{process.datesEstimatedCustomerDeliverDate ? formatData(process.datesEstimatedCustomerDeliverDate) : 'N/I'}}</span>
            </div>
          </div>
        </div>

        <div class="span-12 medium-border-radius border-form gap2 mb-1 ph-2 pb-2 pt-2">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold mb-1 text-primary"> DATAS CONFIRMADAS </h5>
            <span class="title-border-bottom"></span>
          </div>

          <div class="gap1 columns">
            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Prontidão de Carga
                </div>
              </div>
              <span class="result-span">{{process.datesGoodsReadinesDate ? formatData(process.datesGoodsReadinesDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Embarque
                </div>
              </div>
              <span class="result-span">{{process.datesDepartureDate ? formatData(process.datesDepartureDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Atracação
                </div>
              </div>
              <span class="result-span">{{process.mooringDate ? formatData(process.mooringDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Chegada
                </div>
              </div>
              <span class="result-span">{{process.datesArrivalDate ? formatData(process.datesArrivalDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Carregamento
                </div>
              </div>
              <span class="result-span">{{process.datesGoodsLoadingDate ? formatData(process.datesGoodsLoadingDate) : 'N/I'}}</span>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c text-light">
                  <CalendarAltIcon class="mr-1"/> Entrega no Cliente
                </div>
              </div>
              <span class="result-span">{{process.datesCustomerDeliverDate ? formatData(process.datesCustomerDeliverDate) : 'N/I'}}</span>
            </div>
          </div>

          <hr class="mb-2 mt-2 hr-tab-general"/>

          <div class="gap1 columns">
            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  <CalendarAltIcon class="mr-1"/> Presença
                </div>
              </div>
              <DatePicker v-model="process.datesGoodsPresenceDate" :disabled="disableClick" placeholder='' @input="onDatesGoodsPresenceDateInput"/>
            </div>

            <div class="span-2 mb-1" v-if="process.duimp != true">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  <CalendarAltIcon class="mr-1"/>  Vistoria RFB
                </div>
              </div>
              <DatePicker v-model="process.datesInspectionOfTheDIDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesInspectionOfTheDIDate')" classInpurt="mb-05"/>
              <small class="flex ai-c" style="gap: 2px;"><InfoIcon size="0.8rem"/><span>Em caso de canal diferente de verde</span></small>
            </div>
            <div class="span-2 mb-1" v-if="process.duimp == true">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">
                  <CalendarAltIcon class="mr-1"/>  Vistoria RFB
                </div>
              </div>
              <DatePicker v-model="process.datesInspectionOfTheDuimpDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesInspectionOfTheDuimpDate')" classInpurt="mb-05"/>
            </div>
            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Vistoria do MAPA
                </div>
              </div>
              <DatePicker v-model="process.datesInspectionMAPADate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesInspectionMAPADate')"/>
            </div>

            <div class="span-2 mb-1">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Liberação do MAPA
                </div>
              </div>
              <DatePicker v-model="process.datesReleaseMAPADate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesReleaseMAPADate')"/>
            </div>
          </div>
        </div>

        <div class="span-6 medium-border-radius border-form gap2 mr-1 mb-1 ph-2 pb-2 pt-2" style="background: #fbfbfb;">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold mb-1 text-primary">  CONHECIMENTO </h5>
            <span class="title-border-bottom"></span>
          </div>
          <div class="gap2 columns">
            <div class="span-3">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Siscarga
                </div>
              </div>
              <DatePicker v-model="process.datesSiscargaDate" :disabled="disableClick" @input="() => inputUpdate('datesSiscargaDate')"/>
            </div>

            <div class="span-3">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Liberação AWB / BL
                </div>
              </div>
              <DatePicker v-model="process.datesBillOfLadingReleaseDate" :disabled="disableClick" @input="() => inputUpdate('datesBillOfLadingReleaseDate')"/>
            </div>

            <div class="span-3">
                <div class="flex ai-c jc-sb mb-1">
                  <div class="flex ai-c ">
                    TFA
                  </div>
                </div>
                <Toggle v-model="process.datesTFASolved" :disabled="disableClick" :labels="{ checked: 'LIBERADO', unchecked: 'PENDENTE', }" name="tfa" @input="() => inputUpdate('datesTFASolved')" classLabel="text-medium text-md"/>
              </div>
            </div>
        </div>

        <div class="span-6 medium-border-radius border-form gap2 mr-1 mb-1 ph-2 pb-2 pt-2" style="background: #fbfbfb;">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold  mb-1 text-primary">  TRANSFERÊNCIA DE CARGA </h5>
            <span class="title-border-bottom"></span>
          </div>
          <div class="gap2 columns">
            <div class="span-4" v-if="process.datesIsThereDTCDTATransfer">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> DTC / DTA
                </div>
              </div>
              <DatePicker v-model="process.datesDTCDTA" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesInspectionOfTheDIDate')"/>
            </div>

            <div class="span-4">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Faturamento do Recinto
                </div>
              </div>
              <DatePicker v-model="process.datesEnclosureBillingDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesEnclosureBillingDate')"/>
            </div>

            <div class="span-4">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Comex
                </div>
              </div>
              <DatePicker v-model="process.datesComexDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesComexDate')"/>
            </div>

            <div class="span-4">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Desova
                </div>
              </div>
              <Toggle v-model="process.datesThereIsDesova" :disabled="true" :labels="{ checked: 'SIM', unchecked: 'NÃO', }" name="sit-siscarga" @input="() => inputUpdate('datesThereIsDesova')" classLabel="text-medium text-md"/>
            </div>

            <div class="span-4" v-if="process.datesThereIsDesova">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/> Data de Desova
                </div>
              </div>
              <DatePicker v-model="process.datesDesova" :disabled="disableClick" placeholder='' @input="() => inputUpdate('datesDesova')"/>
            </div>
          </div>
        </div>

        <div class="span-12 medium-border-radius border-form gap2 mb-1 ph-2 pb-2 pt-2" style="grid-row: span 3;" v-if="process.duimp != true">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold mb-1 text-primary">  DECLARAÇÃO DE IMPORTAÇÃO</h5>
            <span class="title-border-bottom"></span>
          </div>
          <div class="gap2 columns">
            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>
                  Data de Digitação
                </div>
              </div>
              <DatePicker v-model="process.diTypingDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('diTypingDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>
                  Data de Registro
                </div>
              </div>
              <DatePicker v-model="process.diRegistryDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('diRegistryDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Número da DI
                </div>
              </div>
              <input v-model="process.diNumber" v-mask="'##/#######-#'" :disabled="disableClick" type="text" @blur="consultDi" @change="() => inputUpdate('diNumber')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Protocolo de Registro da DI
                </div>
              </div>
              <input v-model="process.diProtocol" :disabled="disableClick" type="text" @change="() => inputUpdate('diProtocol')" maxlength="10"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>Data de Desembaraço
                </div>
              </div>
              <DatePicker v-model="process.diResourcefulnessDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('diResourcefulnessDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c" style="gap: 3px">
                  Canal <span v-if="process.diChannel" :class="process.diChannel === 'VERDE' ? 'text-success' : process.diChannel === 'AMARELO' ? 'text-warning' : process.diChannel === 'VERMELHO' ? 'text-danger' : process.diChannel === 'CINZA' ? '' : '' "> <strong>{{ process.diChannel }}</strong> </span>
                </div>
              </div>
              <select
                v-model="process.diChannel"
                :disabled="disableClick || isChannelParameterizationLocked"
                class="custom-select form-control wd-100"
                name="diChannel"
                @focus="channelParameterizationPreviousValue = process.diChannel"
                @change="onDiChannelChange"
              >
                <option value></option>
                <option value="VERDE">Verde</option>
                <option value="AMARELO">Amarelo</option>
                <option value="VERMELHO">Vermelho</option>
                <option value="CINZA">Cinza</option>
              </select>
            </div>

            <div class="span-2" v-if="isParameterizationChannel(process.diChannel)">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">Órgão Anuente</div>
              </div>
              <input v-model="process.consentingAgency" type="text" disabled />
            </div>

            <div class="span-2" v-if="isParameterizationChannel(process.diChannel)">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c"><CalendarAltIcon class="mr-1"/>Data de Parametrização</div>
              </div>
              <DatePicker v-model="process.parameterizationDate" :disabled="true" placeholder='' />
            </div>

            <!-- <div class="span-12 mt-1">
              <div class="text-center">
                <DoubleCheckIcon class="mb-1" :class="process.diChannel === 'VERDE' ? 'text-success' : process.diChannel === 'AMARELO' ? 'text-warning' : process.diChannel === 'VERMELHO' ? 'text-danger' : process.diChannel === 'CINZA' ? '' : '' " size="3rem"/>
                <h4 class="text-bold text-center mb-2 text-primary"> DESEMBARAÇADO</h4>
                <p v-if="process.diChannel" :class="process.diChannel === 'VERDE' ? 'text-success' : process.diChannel === 'AMARELO' ? 'text-warning' : process.diChannel === 'VERMELHO' ? 'text-danger' : process.diChannel === 'CINZA' ? '' : '' "> Canal <strong>{{ process.diChannel }}</strong> </p>
                <p v-else>Nenhum canal informado</p>
              </div>
            </div> -->
          </div>
        </div>

        <div class="span-12 medium-border-radius border-form gap2 mb-1 ph-2 pb-2 pt-2" style="grid-row: span 3;" v-if="process.duimp == true">
          <div class="flex mt-1 mb-2 fd-c">
            <h5 class="text-bold mb-1 text-primary">  DUIMP - Declaração Única de Importação </h5>
            <span class="title-border-bottom"></span>
          </div>
          <div class="gap2 columns">
            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>
                  Data de Digitação
                </div>
              </div>
              <DatePicker v-model="process.duimpTypingDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('duimpTypingDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>
                  Data de Registro
                </div>
              </div>
              <DatePicker v-model="process.duimpRegistryDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('duimpRegistryDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Número do Registro
                </div>
              </div>
              <input v-model="process.duimpIdentification" :disabled="disableClick" type="text" @change="onDuimpIdentificationChange" v-mask="'##BR##########-#'"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Versão
                </div>
              </div>
              <input v-model="process.duimpVersion" class="imput-number" :disabled="disableClick" type="number"  @change="() => inputUpdate('duimpVersion')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  Chave de Acesso
                </div>
              </div>
              <input v-model="process.duimpAccessKey" class="imput-number" :disabled="disableClick" type="text"  @change="() => inputUpdate('duimpAccessKey')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c ">
                  <CalendarAltIcon class="mr-1"/>Data de Desembaraço
                </div>
              </div>
              <DatePicker v-model="process.duimpResourcefulnessDate" :disabled="disableClick" placeholder='' @input="() => inputUpdate('duimpResourcefulnessDate')"/>
            </div>

            <div class="span-2">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c" style="gap: 3px">
                  Canal<span v-if="process.duimpChannel" :class="process.duimpChannel === 'VERDE' ? 'text-success' : process.duimpChannel === 'AMARELO' ? 'text-warning' : process.duimpChannel === 'VERMELHO' ? 'text-danger' : process.duimpChannel === 'CINZA' ? '' : '' "> <strong>{{ process.duimpChannel }}</strong> </span>
                </div>
              </div>
              <select
                v-model="process.duimpChannel"
                :disabled="disableClick || isChannelParameterizationLocked"
                class="custom-select form-control wd-100"
                name="duimpChannel"
                @focus="channelParameterizationPreviousValue = process.duimpChannel"
                @change="onDuimpChannelChange"
              >
                <option value></option>
                <option value="VERDE">Verde</option>
                <option value="AMARELO">Amarelo</option>
                <option value="VERMELHO">Vermelho</option>
                <option value="CINZA">Cinza</option>
              </select>
            </div>

            <div class="span-2" v-if="isParameterizationChannel(process.duimpChannel)">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c">Órgão Anuente</div>
              </div>
              <input v-model="process.consentingAgency" type="text" disabled />
            </div>

            <div class="span-2" v-if="isParameterizationChannel(process.duimpChannel)">
              <div class="flex ai-c jc-sb mb-1">
                <div class="flex ai-c"><CalendarAltIcon class="mr-1"/>Data de Parametrização</div>
              </div>
              <DatePicker v-model="process.parameterizationDate" :disabled="true" placeholder='' />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <Modal
    class="channel-parameterization-modal"
    :backgroundOpacity="0.95"
    :closeButton="true"
    :handler="modalChannelParameterizationOpen"
    :maxWidth="40"
    :useActions="true"
    @request-close="cancelChannelParameterizationModal"
  >
    <template #head>
      <h5 class="text-bold text-primary">Parametrização de Canal</h5>
    </template>
    <template #content>
      <p class="mb-2">Informe o Órgão Anuente e a Data de Parametrização.</p>
      <div class="mb-2">
        <label class="text-medium mb-05">Órgão Anuente *</label>
        <Select
          class="select-form"
          classStyledSelect="channel-parameterization-agency-select"
          classSelectList="select-new"
          v-model="channelParameterizationDraft.consentingAgency"
          :options="licensingAuthorityOptions"
          :title="null"
        />
      </div>
      <div class="mb-2">
        <label class="text-medium mb-05">Data de Parametrização *</label>
        <DatePicker v-model="channelParameterizationDraft.parameterizationDate" placeholder="Selecione" />
      </div>
    </template>
    <template #cancel-button>
      <a class="btn solid danger mr-2" href="#" @click.prevent="cancelChannelParameterizationModal">
        CANCELAR
      </a>
    </template>
    <template #confirm-button>
      <a
        class="btn solid success"
        href="#"
        :class="{ disabled: !isChannelParameterizationDraftValid }"
        @click.prevent="confirmChannelParameterizationModal"
      >
        CONFIRMAR
      </a>
    </template>
  </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mask } from 'vue-the-mask';
import { VMoney } from 'v-money';
import moment from 'moment';
import api from '@/services/api';
import { actions } from '@/services/webocket';

import {
  BuildingIcon,
  InvoiceIcon,
  IdCardIcon,
  CalendarAltIcon,
  InfoIcon,
  DoubleCheckIcon,
  IndustryIcon,
  FileIcon,
  MapPinIcon,
  BoxesIcon,
} from '@/components/Icons';
import Toggle from '@/components/DataInput/Toggle.vue';
import DatePicker from '@/components/DataInput/DatePicker.vue';
import Select from '@/components/DataInput/Select.vue';
import Modal from '@/components/Modal.vue';

export default {
  name: 'ModalProcessTabGeneral',
  directives: {
    mask,
    money: VMoney,
  },
  components: {
    // Icons
    BuildingIcon,
    InvoiceIcon,
    IdCardIcon,
    CalendarAltIcon,
    InfoIcon,
    DoubleCheckIcon,
    IndustryIcon,
    FileIcon,
    MapPinIcon,
    BoxesIcon,
    // Componenets
    Toggle,
    DatePicker,
    Select,
    Modal,
  },
  props: {
    process: {
      type: Object,
      default: () => {},
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    disableClick: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      changed: false,
      moneyFormat: {
        decimal: ',',
        thousands: '.',
      },
      modalChannelParameterizationOpen: false,
      channelParameterizationField: null,
      channelParameterizationPreviousValue: null,
      channelParameterizationDraft: {
        channel: null,
        consentingAgency: '',
        parameterizationDate: null,
      },
      licensingAuthorityOptions: [],
    };
  },
  computed: {
    ...mapState('process', ['socket']),
    ceMercanteCheckedSelectValue() {
      const v = this.process && this.process.ceMercanteChecked;
      if (v === true || v === 'true') return 'true';
      if (v === false || v === 'false') return 'false';
      return 'null';
    },
    /** Cor de destaque do controle (alinha ao Gescomex: neutro / sucesso / divergência). */
    ceMercanteCheckedToneClass() {
      const key = this.ceMercanteCheckedSelectValue;
      if (key === 'true') return 'ce-mercante-situacao-wrap--conferido';
      if (key === 'false') return 'ce-mercante-situacao-wrap--divergente';
      return 'ce-mercante-situacao-wrap--pendente';
    },
    isChannelParameterizationLocked() {
      return !!(
        (this.process.consentingAgency && String(this.process.consentingAgency).trim())
        || this.process.parameterizationDate
      );
    },
    isChannelParameterizationDraftValid() {
      const agency = (this.channelParameterizationDraft.consentingAgency || '').trim();
      return !!(agency && this.channelParameterizationDraft.parameterizationDate && this.channelParameterizationDraft.channel);
    },
  },
  methods: {
    isParameterizationChannel(channel) {
      return channel === 'AMARELO' || channel === 'VERMELHO' || channel === 'CINZA';
    },
    async loadLicensingAuthorityOptions() {
      try {
        const response = await api.get('/licensing-authorities');
        this.licensingAuthorityOptions = [];
        if (response?.data?.data) {
          this.licensingAuthorityOptions = response.data.data.map((item) => ({
            label: `${item.acronym} - ${item.name}`,
            value: item.acronym,
          }));
        }
      } catch (e) {
        this.licensingAuthorityOptions = [];
      }
    },
    onDiChannelChange() {
      this.handleChannelParameterizationChange('diChannel');
    },
    onDuimpChannelChange() {
      this.handleChannelParameterizationChange('duimpChannel');
    },
    async handleChannelParameterizationChange(field) {
      const selected = this.process[field];
      if (!this.isParameterizationChannel(selected)) {
        this.inputUpdate(field);
        return;
      }

      if (this.isChannelParameterizationLocked
        || this.isParameterizationChannel(this.channelParameterizationPreviousValue)) {
        this.process[field] = this.channelParameterizationPreviousValue || '';
        this.$toast.error('Já existe Canal, Órgão Anuente ou Data de Parametrização cadastrados para este processo.');
        return;
      }

      await this.loadLicensingAuthorityOptions();
      this.channelParameterizationField = field;
      this.channelParameterizationDraft = {
        channel: selected,
        consentingAgency: this.process.consentingAgency || '',
        parameterizationDate: this.process.parameterizationDate || null,
      };
      this.process[field] = this.channelParameterizationPreviousValue || '';
      this.modalChannelParameterizationOpen = true;
    },
    cancelChannelParameterizationModal() {
      if (this.channelParameterizationField) {
        this.process[this.channelParameterizationField] = this.channelParameterizationPreviousValue || '';
      }
      this.modalChannelParameterizationOpen = false;
      this.channelParameterizationField = null;
      this.channelParameterizationPreviousValue = null;
      this.channelParameterizationDraft = {
        channel: null,
        consentingAgency: '',
        parameterizationDate: null,
      };
    },
    async confirmChannelParameterizationModal() {
      if (!this.isChannelParameterizationDraftValid || !this.process.id) {
        return;
      }

      const payload = {
        channel: this.channelParameterizationDraft.channel,
        consentingAgency: (this.channelParameterizationDraft.consentingAgency || '').trim(),
        parameterizationDate: moment(this.channelParameterizationDraft.parameterizationDate).format('YYYY-MM-DD'),
      };

      try {
        this.toggleLoading(true);
        const response = await api.post(
          `/api/public/partner/processes/${this.process.id}/channel-parameterization`,
          payload,
        );

        if (response.data && response.data.code === 'SUCCESS' && response.data.data) {
          const saved = response.data.data;
          this.process.diChannel = saved.diChannel;
          this.process.duimpChannel = saved.duimpChannel;
          this.process.consentingAgency = saved.consentingAgency;
          this.process.parameterizationDate = saved.parameterizationDate;

          const processId = this.process.id;
          const websocketFields = {
            diChannel: saved.diChannel,
            duimpChannel: saved.duimpChannel,
            consentingAgency: saved.consentingAgency,
            parameterizationDate: saved.parameterizationDate,
          };
          if (this.socket && this.socket.readyState === 1 && processId) {
            Object.keys(websocketFields).forEach((fieldName) => {
              this.socket.send(
                JSON.stringify({
                  action: actions.UPDATE_PROC,
                  data: {
                    [processId]: {
                      [fieldName]: websocketFields[fieldName],
                    },
                  },
                }),
              );
            });
          }

          this.modalChannelParameterizationOpen = false;
          this.channelParameterizationField = null;
          this.$toast.success('Parametrização registrada com sucesso!');
        } else {
          this.$toast.error((response.data && response.data.message) || 'Não foi possível registrar a parametrização.');
          this.cancelChannelParameterizationModal();
        }
      } catch (error) {
        this.$toast.error(
          (error.data && error.data.message)
          || (error.response && error.response.data && error.response.data.message)
          || 'Não foi possível registrar a parametrização.',
        );
        this.cancelChannelParameterizationModal();
      } finally {
        this.toggleLoading(false);
      }
    },
    formatData(data) {
      if (data) {
        return moment(data).format('DD/MM/YYYY');
      }

      return null;
    },
    returnProcessUseOfGoods(processUseOfGoods) {
      if (processUseOfGoods && processUseOfGoods.length > 0) {
        return processUseOfGoods.map((processUseOfGood) => processUseOfGood.description).join(', ');
      }

      return 'N/I';
    },
    async copyTeamEmail(email) {
      if (!email) {
        this.$toast.error('E-mail não disponível');
        return;
      }

      const toastOptions = { timeout: 5000 };

      try {
        await navigator.clipboard.writeText(email);
        this.$toast.success('E-mail copiado com sucesso!', toastOptions);
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = email;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$toast.success('E-mail copiado com sucesso!', toastOptions);
      }
    },
    ...mapActions(['toggleLoading']),
    ...mapActions('process', ['patchProcess']),
    onCeMercanteCheckedChange(e) {
      const val = e.target.value;
      if (val === 'true') {
        this.$set(this.process, 'ceMercanteChecked', true);
      } else if (val === 'false') {
        this.$set(this.process, 'ceMercanteChecked', false);
      } else {
        this.$set(this.process, 'ceMercanteChecked', null);
      }
      this.inputUpdate('ceMercanteChecked');
    },
    async onDatesGoodsPresenceDateInput() {
      await this.inputUpdate('datesGoodsPresenceDate');
      setTimeout(async () => {
        await this.$emit('goods-presence-date-changed');
      }, 3000);
    },
    onDuimpIdentificationChange() {
      if (this.process.duimpVersion == null || this.process.duimpVersion === '') {
        this.$set(this.process, 'duimpVersion', 1);
      }
      this.inputUpdate('duimpIdentification');
    },
    async inputUpdate(field) {
      if (this.changed) {
        this.toggleLoading(true);
        const data = {
          identification: this.process.identification,
          fieldUpdated: field,
          data: this.process,
        };
        await this.patchProcess(data);
      }
    },
    async consultDi() {
      if (this.process.diNumber.length === 12) {
        this.toggleLoading(true);
        const response = await api.get(
          `/integrations/myimp/consultarDi?processId=${this.process.id}&diIdentification=${this.process.diNumber}`,
        );

        if (response.data) {
          this.process.diRegistryDate = response.data.registryDate;
          this.process.diResourcefulnessDate = response.data.resourcefulnessDate;

          this.$toast.success('Dados encontrados com sucesso!');
        } else {
          this.$toast.error('Nenhuma informação encontrada');
        }

        this.toggleLoading(false);
      }
    },
    async consultDuimp() {
      if (this.process.duimpIdentification.length === 13) {
        this.toggleLoading(true);
        const response = await api.get(
          `/integrations/myimp/consultarDuimp?processId=${this.process.id}&duimpIdentification=${this.process.duimpIdentification}`,
        );

        if (response.data) {
          this.process.duimpRegistryDate = response.data.registryDate;
          this.process.duimpResourcefulnessDate = response.data.resourcefulnessDate;

          this.$toast.success('Dados encontrados com sucesso!');
        } else {
          this.$toast.error('Nenhuma informação encontrada');
        }

        this.toggleLoading(false);
      }
    },
  },
  updated() {
    this.changed = true;
  },
};
</script>

<style scoped>
.border-form {
  border: 1px solid #e2e2e2;
}
.title-border-bottom {
  border-bottom: var(--small-border-width) solid var(--input-border-color);
  width: 100%;
}
.hr-tab-general {
  border-color: #f2f2f2;
  border-top-width: 2px;
}

.team-email-display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.10rem;
}

.result-span-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.result-span-with-icon__text {
  line-height: 1.25;
}

.result-span-with-icon__icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: var(--light-text-color, #6c757d);
}

.tooltip-team-email {
  display: inline-flex;
  align-items: center;
  cursor: help;
}

.tooltip-team-email__trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tooltip-team-email .content {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 50%;
  transform: translateX(-50%) translateY(-2px);
  padding: 0.35rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--white-color);
  background-color: var(--dark-text-color, #333);
  border-radius: var(--small-border-radius, 4px);
  width: max-content;
  max-width: none;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tooltip-team-email .content::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -4px;
  border-width: 0 4px 4px 4px;
  border-style: solid;
  border-color: transparent transparent var(--dark-text-color, #333) transparent;
}

.tooltip-team-email:hover .content {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.team-email-copy {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--primary-color);
  cursor: pointer;
}

.team-email-copy:hover {
  text-decoration: underline;
}

.team-email-copy__icon {
  flex-shrink: 0;
}

/* Situação CE Mercante: seta + cores por valor selecionado */
.ce-mercante-situacao-wrap {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  border-radius: 6px;
  border: 1px solid var(--ce-sit-border, #c5cdd8);
  background: var(--ce-sit-bg, #f4f6f9);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.ce-mercante-situacao-wrap--pendente {
  --ce-sit-border: #b0bac8;
  --ce-sit-bg: #eef1f6;
  --ce-sit-fg: #3d4a5c;
}

.ce-mercante-situacao-wrap--conferido {
  --ce-sit-border: #2b9c6a;
  --ce-sit-bg: #e4f6ec;
  --ce-sit-fg: #146b42;
}

.ce-mercante-situacao-wrap--divergente {
  --ce-sit-border: #dc3545;
  --ce-sit-bg: #fde8ea;
  --ce-sit-fg: #a61e2b;
}

.ce-mercante-situacao-wrap:not(.ce-mercante-situacao-wrap--disabled):hover {
  box-shadow: 0 0 0 2px rgba(16, 67, 117, 0.12);
}

.ce-mercante-situacao-wrap--disabled {
  opacity: 0.72;
  cursor: not-allowed;
}

.ce-mercante-situacao-select {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0.45rem 2.15rem 0.45rem 0.55rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--ce-sit-fg, #333);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.ce-mercante-situacao-select:disabled {
  cursor: not-allowed;
}

.ce-mercante-situacao-select:focus {
  outline: none;
}

.ce-mercante-situacao-wrap:focus-within:not(.ce-mercante-situacao-wrap--disabled) {
  box-shadow: 0 0 0 2px rgba(16, 67, 117, 0.22);
}

.ce-mercante-situacao-chevron {
  position: absolute;
  right: 0.45rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: var(--ce-sit-fg, #333);
  opacity: 0.92;
}

.ce-mercante-situacao-chevron__svg {
  display: block;
}

.imput-number {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Para Chrome e Safari */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .imput-number::-webkit-inner-spin-button,
  .imput-number::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

/* Para Firefox */
@-moz-document url-prefix() {
  .imput-number::-moz-inner-spin-button,
  .imput-number::-moz-outer-spin-button {
    -moz-appearance: none;
    margin: 0;
  }
}
</style>

<style>
.channel-parameterization-modal .modal-content-wrapper {
  overflow: visible !important;
}

.channel-parameterization-modal .modal-content {
  overflow: visible !important;
}

.channel-parameterization-modal .select-new {
  width: 100%;
  height: 2.8125rem !important;
  border: var(--input-border) !important;
  border-radius: var(--medium-border-radius) !important;
  padding: 0 2.5rem 0 1rem !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  background-color: var(--white-color) !important;
  font-size: 1rem;
  color: #000000;
  font-weight: bold;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
}

.channel-parameterization-modal .select-new .title {
  display: none;
}

.channel-parameterization-modal .select-new .selected-option {
  margin-top: 0 !important;
  height: auto !important;
  line-height: 1.2;
  text-overflow: unset !important;
  width: 100% !important;
}

.channel-parameterization-modal .select-new .options {
  z-index: 10;
  max-height: none;
}

.channel-parameterization-modal .channel-parameterization-agency-select {
  position: relative;
  z-index: 2;
}
</style>
